var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 63,
    width: 645,
    height: 3.87,
    rx: 1.935,
    fill: "#0BAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.115,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 43.795,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 33.475,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 23.155,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 12.835,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 2.515,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 767.485,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 757.165,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 746.845,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 736.525,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 726.205,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 715.885,
    cy: 2.195,
    r: 1.935,
    fill: "#0BAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.2b773c9c940bfe039a5e14c734b1b025.svg";
export { ForwardRef as ReactComponent };